var _rect, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 54.6851,
    height: 54.5011,
    rx: 6.60502,
    transform: "matrix(0.940174 0.340694 -0.34335 0.939207 20.582 0)",
    fill: "url(#paint0_linear_13482_16065)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13482_16065)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17.5986,
    width: 54.7131,
    height: 54.473,
    rx: 6.60502,
    fill: "url(#paint1_radial_13482_16065)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13482_16065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5072 47.7679C28.7608 48.2489 27.8938 48.5032 27 48.5032C26.1062 48.5032 25.2393 48.2489 24.4929 47.7679L12.1997 39.8455C12.1315 39.8015 12.0651 39.7557 12 39.7086V52.6904C12 54.1788 13.2495 55.3601 14.7617 55.3601H39.2382C40.778 55.3601 41.9999 54.1522 41.9999 52.6904V39.7085C41.9347 39.7557 41.8682 39.8017 41.7998 39.8457L29.5072 47.7679Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13482_16065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1748 38.4315L25.4679 46.354C25.9333 46.6539 26.4666 46.8039 26.9999 46.8039C27.5333 46.8039 28.0667 46.6539 28.5321 46.354L40.8252 38.4315C41.5608 37.9577 42 37.1647 42 36.3089C42 34.8373 40.7615 33.6401 39.2392 33.6401H14.7608C13.2385 33.6402 12 34.8373 12 36.3103C12 37.1647 12.4392 37.9577 13.1748 38.4315V38.4315Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13482_16065",
    x: -1.9815,
    y: 15.6171,
    width: 58.6779,
    height: 58.4362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.990752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13482_16065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13482_16065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13482_16065",
    x: 12,
    y: 39.7085,
    width: 39.418,
    height: 25.0694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13482_16065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13482_16065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13482_16065",
    x: 12,
    y: 33.6401,
    width: 39.418,
    height: 22.5816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13482_16065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13482_16065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13482_16065",
    x1: 11.4352,
    y1: 13.8397,
    x2: 67.0932,
    y2: 35.3658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4C97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13482_16065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3566 44.8351) rotate(90) scale(29.9602 30.0922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A1ED",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93A1ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b7ba42187fd9e73af32c2d629c9f359c.svg";
export { ForwardRef as ReactComponent };